import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { submitConsents } from '../services/consentService';
import './ConsentPage.css';

const ConsentPage = () => {
  const [consents] = useState([
    {
      id: 1,
      title: '[1] 개인정보 처리방침',
      content: (
        <>
          <p>
            <strong>BnH세무법인</strong>에서 취급하는 모든 개인정보는 개인정보 보호법 등 관련 법령상의 개인정보보호
            규정을 준수하여 이용자의 개인정보 보호 및 권익을 보호하고 개인정보 보호와 관련한 이용자의 고충을
            원활하게 처리할 수 있도록 아래와 같이 개인정보 처리방침을 운영합니다.
          </p>
          <p><strong>제1조 (개인정보의 처리목적)</strong></p>
          <p>
            <strong>BnH세무법인</strong>은 종합소득세 신고를 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는
            종합소득세 신고 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법
            제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
          </p>
          <p><strong>제2조 (개인정보 파일현황 및 보유기간)</strong></p>
          <p>
            <strong>BnH세무법인</strong>은 국세기본법에 따라 신고 서류 및 장부는 5년간(역외거래의 경우 7년간) 또는
            정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 처리 및 보유합니다.
          </p>
          <p><strong>제3조 (개인정보의 제3자 제공에 관한 사항)</strong></p>
          <p>
            ① <strong>BnH세무법인</strong>은 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에
            해당하는 경우에만 개인정보를 제3자에게 제공합니다.
          </p>
          <p>
            ② 제1항에도 불구하고 개인정보처리자는 다음 각 호의 어느 하나에 해당하는 경우에는 정보주체 또는
            제3자의 이익을 부당하게 침해할 우려가 있을 때를 제외하고는 개인정보를 목적 외의 용도로 이용하거나 이를
            제3자에게 제공할 수 있습니다. 다만, 제4호부터 제7호까지의 경우는 공공기관의 경우로 한정합니다.
          </p>
          <ol>
            <li>정보주체로부터 별도의 동의를 받은 경우</li>
            <li>다른 법률에 특별한 규정이 있는 경우</li>
            <li>
              정보주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을 수 없는
              경우로서 명백히 정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우
            </li>
            <li>조약, 그 밖의 국제협정의 이행을 위하여 외국정부 또는 국제기구에 제공하기 위하여 필요한 경우</li>
            <li>범죄의 수사와 공소의 제기 및 유지를 위하여 필요한 경우</li>
            <li>법원의 재판업무 수행을 위하여 필요한 경우</li>
            <li>형(刑) 및 감호, 보호처분의 집행을 위하여 필요한 경우</li>
          </ol>
          <p>
            ③ <strong>BnH세무법인</strong>은 정보주체로부터 별도의 동의를 받은 경우를 제외하고 관할 세무서 및 지방자치단체
            외에는 개인정보를 제3자에게 제공하지 않습니다.
          </p>
          <p>④ <strong>BnH세무법인</strong>은 개인정보 제공사유가 발생하였을 경우에만 개인정보가 제3자에게 제공됩니다.</p>
          <p>
            ⑤ 정보주체는 개인정보의 제3자 제공에 대한 동의를 거부할 권리가 있으며, 동의 거부 시
            <strong>BnH세무법인</strong>에서 제공하는 종합소득세 신고 서비스가 제한됩니다.
          </p>
          <p><strong>제4조 (정보주체와 법정대리인의 권리·의무 및 행사방법)</strong></p>
          <p>① 정보주체는 <strong>BnH세무법인</strong>에 대해 언제든지 개인정보 열람, 정정, 삭제, 처리정지 요구 등의 권리를 행사할 수 있습니다.</p>
          <p>
            ② 제1항에 따른 권리 행사는 <strong>BnH세무법인</strong>에 대해 개인정보 보호법 시행령 제41조 제1항에 따라
            서면, 전자우편, 모사전송(FAX) 등을 통해 하실 수 있으며 <strong>BnH세무법인</strong>은 이에 대해 지체 없이 조치하겠습니다.
          </p>
          <p>
            ③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 할 수 있습니다.
            이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하여야 합니다.
          </p>
          <p>
            ④ 개인정보 열람 및 처리정지 요구는 개인정보 보호법 제35조 제5항과 제37조 제2항에 의하여
            정보주체의 권리가 제한될 수 있습니다.
          </p>
          <p>⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</p>
          <p>⑥ <strong>BnH세무법인</strong>은 정보주체 권리에 따른 열람의 요구, 정정, 삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.</p>
          <p>
            ⑦ 이용자는 <strong>BnH세무법인</strong> 서비스의 사용 종료 시마다 정확히 접속을 종료해야 하며, 정확히 종료하지 아니함으로써
            제3자가 귀하에 관한 정보를 이용하게 되는 등의 결과로 인해 발생하는 손해 및 손실에 대하여
            <strong>BnH세무법인</strong>은 책임을 부담하지 아니합니다.
          </p>
        </>
      ),
    },
    {
      id: 2,
      title: '[2] 개인정보 수집이용 동의서',
      content: (
        <>
          <p><strong>가. 개인정보의 수집 및 이용 목적</strong></p>
          <p>
            <strong>BnH세무법인</strong>은 종합소득세 신고 목적을 위해 개인정보를 수집 및 이용합니다.
            수집된 개인정보는 종합소득세 신고 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는
            개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
          </p>
          <p><strong>나. 수집하는 개인정보의 항목</strong></p>
          <p>• 수집 항목: 성명, 주민등록번호(외국인등록번호), 주소, 전화번호, 이메일, 사업자등록번호, 계좌번호, 부양가족 정보, 소득공제 및 세액공제 내역, 종합소득 및 필요경비 내역</p>
          <p>
            정보주체는 개인정보의 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의 거부 시에는
            <strong>BnH세무법인</strong>에서 제공하는 종합소득세 신고 서비스가 제한됩니다.
          </p>
        </>
      ),
    },
    {
      id: 3,
      title: '[3] 고유식별정보 처리 동의서',
      content: (
        <>
          <p>
            <strong>BnH세무법인</strong>은 다음과 같이 고유식별정보 처리(수집이용 및 제3자 제공)를 하고 있으며,
            종합소득세 신고에 사용하는 개인정보는 개인정보 보호법 제22조 제3항에 따라 정보주체의 동의 없이
            처리할 수 있는 개인정보로 지정합니다.
          </p>
          <p><strong>• 고유식별정보: 주민등록번호, 외국인등록번호 (본인 및 부양가족 포함)</strong></p>
        </>
      ),
    },
  ]);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const allAgreements = {};
      consents.forEach((consent) => {
        allAgreements[consent.id] = true;
      });
      await submitConsents(allAgreements);
      navigate('/basic-info');
    } catch (error) {
      setMessage('동의서 제출에 실패했습니다.');
      setMessageType('error');
      console.error('동의서 제출 실패:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="consent-page">
      <h1>개인정보 보호법에 따른 동의</h1>

      <div className="consents-list">
        {consents.map((consent) => (
          <div key={consent.id} className="consent-item">
            <div className="consent-header">
              <h2>{consent.title}</h2>
            </div>
            {consent.content && <div className="consent-content">{consent.content}</div>}
          </div>
        ))}
      </div>

      <div className="submit-section">
        {message && <div className={`consent-message ${messageType}`}>{message}</div>}
        <button
          onClick={handleSubmit}
          className="submit-btn"
          disabled={submitting || consents.length === 0}
        >
          {submitting ? '제출 중...' : '위의 내용에 모두 동의합니다'}
        </button>
      </div>
    </div>
  );
};

export default ConsentPage;

